<template>
  <v-row justify="center">
    <v-col
      cols="12"
      sm="10"
    >
      <base-material-card>
        <template v-slot:heading>
          <div class="subtitle-1 font-weight-light">
            Редактирование атрибутов
          </div>
        </template>
        <v-card-text>
          <div>
            <v-row>
              <v-col
                cols="12"
                md="6"
                sm="12"
              >
                <v-text-field
                  v-model="attribute.name"
                  hint="Наименование атрибута"
                  label="Наименование"
                  placeholder="Наименование атрибута"
                />
              </v-col>
              <v-col
                cols="12"
                md="6"
                sm="12"
              >
                <v-text-field
                  v-model="attribute.mnemonic"
                  hint="Мнемоника атрибута"
                  label="Мнемоника"
                  placeholder="Мнемоника атрибута"
                />
              </v-col>
            </v-row>
            <v-row>
              <v-col
                cols="12"
                md="6"
                sm="12"
              >
                <v-select
                  v-model="attribute.type"
                  :items="typeList"
                  hint="Тип атрибута"
                  label="Тип"
                  placeholder="Тип атрибута"
                  item-text="text"
                  item-value="value"
                />
              </v-col>
              <v-col
                cols="12"
                md="6"
                sm="12"
              >
                <v-switch
                  v-model="attribute.deleted"
                  label="Удалён"
                />
              </v-col>
            </v-row>
          </div>
        </v-card-text>
        <v-divider />
        <v-card-actions>
          <v-row
            align-content="space-between"
            justify="space-around"
          >
            <v-btn
              color="primary"
              outlined
              @click="$router.back()"
            >
              Назад
            </v-btn>
            <v-btn
              :disabled="newNameInvalid"
              color="primary"
              @click="attribute_length ? save() : create()"
            >
              {{ attribute_length ? "Сохранить" : "Создать" }}
            </v-btn>
          </v-row>
        </v-card-actions>
      </base-material-card>
    </v-col>
  </v-row>
</template>

<script>
import WebApi from "@/views/loyalty/shared/modules/web_api"
import { AttributeService } from "@/views/loyalty/shared/services/attribute_service"

export default {
  name: "AttributeEdit",
  data: () => ({
  attribute: {}
}),
  computed: {
    attribute_length () {
      console.log('Object.keys(this.attribute)', Object.keys(this.attribute).length)
      console.log('this.attribute.attributeId', this.attribute.attributeId)
      return this.attribute.attributeId !== undefined
    },
    newNameInvalid () {
      return !this.attribute.name || !this.attribute.mnemonic
    },
    typeList () {
      return AttributeService.getTypes()
    },
  },
  mounted () {
    const attributeId = this.$route.params.attributeId
    console.log('attributeId', attributeId)
    this.webApi = new WebApi(this.$store)
        .createSuccess("Атрибут создан!")
        .createError("Произошла ошибка при создании Атрибута!")
        .editSuccess("Атрибут сохранён!")
        .editError("Произошла ошибка при сохранении Атрибута!")
        .readError("Произошла ошибка при считывании данных!")
    if (attributeId !== '' && attributeId !== '0') {
      this.webApi
          .get(`${process.env.VUE_APP_LOYALTY_URL}api/attribute/${attributeId}`)
          .then(data => {
            this.attribute = data
          })
    }
  },
  methods: {
    create () {
      const that = this
      this.webApi
          .post(`${process.env.VUE_APP_LOYALTY_URL}api/attribute/`, this.attribute)
          .then(function (data) {
            console.log(data)
            that.attribute.attributeId = data.attributeId
          })
    },
    save () {
      this.webApi
          .patch(`${process.env.VUE_APP_LOYALTY_URL}api/attribute/${this.attribute.attributeId}`, this.attribute)
          .then(function (data) {
            console.log(data)
          })
    }
  }
}
</script>

<style scoped>

</style>
